import React from 'react';
import { connect } from 'react-redux';
import RecentActivitesWrapper from './RecentActivities.style';
import { Card } from 'antd';
  
const RecentActivities  = () => {
  return (
    <RecentActivitesWrapper>
        <div className="recent-activities">
          <Card title="Recent Activity" bordered={false}>
            <p>asdasdasd</p>      
          </Card>
        </div>
    </RecentActivitesWrapper>
  );
}

function mapToStateProps(state) {
    return state;
}

const mapDispatchToProps = {

}

export default connect(mapToStateProps, mapDispatchToProps)(RecentActivities);


// WEBPACK FOOTER //
// ./src/components/Main/RecentActivities/RecentActivities.js